import React from 'react';
import PropTypes from 'prop-types';
import styles from './ImageArraySections.pcss';

export default class ImageArraySections extends React.Component {
    static propTypes = {
        sectionData: PropTypes.object
    };
    static defaultProps = {
        sectionData: {}
    };

    render() {
        const images = this.props.sectionData.get('items').toJS() || [];
        return (
            <div className={styles.section}>
                <div className={styles.benefits}>
                    {images.map((item, key) => (
                        <a
                            href={item.link}
                            className={styles.detail}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={key}>
                            <div className={styles.container}>
                                <img
                                    className={styles.detailEntry}
                                    src={item.image}
                                    alt={item.title}
                                />
                                <div className={styles.hoverStyle}>
                                    {item.title}
                                    <div className={styles.subText}>{item.text}</div>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        );
    }
}
